/*
* <div class="tabs">
		<div class="tab-links">
			<ul id="tabs" role="tablist">
				<li class="tab-link" role="presentation">
					<button class="active" id="tab-1" data-target="#tab-content-1" type="button" role="tab" aria-controls="tab-content-1" aria-selected="true">
						Tab Link 1
					</button>
				</li>
				<li class="tab-link" role="presentation">
					<button id="tab-2" data-target="#tab-content-2" type="button" role="tab" aria-controls="tab-content-2" aria-selected="false">
						Tab Link 2
					</button>
				</li>
				<li class="tab-link" role="presentation">
					<button id="tab-3" data-target="#tab-content-3" type="button" role="tab" aria-controls="tab-content-3" aria-selected="false">
						Tab Link 3
					</button>
				</li>
			</ul>
		</div>
		<div class="tab-content">
			<div class="tab-pane fade active" id="tab-content-1" role="tabpanel" aria-labelledby="tab-1">
				// tab content 1
			</div>
			<div class="tab-pane fade active" id="tab-content-2" role="tabpanel" aria-labelledby="tab-2">
				// tab content 2
			</div>
			<div class="tab-pane fade active" id="tab-content-3" role="tabpanel" aria-labelledby="tab-3">
				// tab content 3
			</div>
		</div>
	</div>
</div>
*/

if (typeof tabs === undefined) {
  let tabs = document.querySelectorAll(".tab-link button");
} else {
  tabs = document.querySelectorAll(".tab-link button");
}

tabs.forEach((element) => {
  element.addEventListener("click", (e) => {
    const element = e.target;
    const targetId = element.dataset.target.substr(1);

    // remove active class from tabs
    tabs.forEach((element) => {
      element.classList.remove("active");
    });

    // remove active class from tab content
    document.querySelectorAll(".tab-pane").forEach((element) => {
      element.classList.remove("active");
    });

    // show correct tab
    element.classList.add("active");
    document.getElementById(targetId).classList.add("active");
  });
});
